(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isSearchModalOpen() || this.isPredictiveSearchOpen()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.isSearchModalOpen()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    isPredictiveSearchOpen() {
      this.predictiveSearches = this.predictiveSearches || this.querySelectorAll('predictive-search');
      return Array.from(this.predictiveSearches).some((predictiveSearch) => predictiveSearch.isOpen);
    }

    isSearchModalOpen() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      return Array.from(this.searchModals).some((searchModal) => {
        if (typeof searchModal.isOpen === 'function') {
          return searchModal.isOpen();
        }

        return searchModal.querySelector('details')?.hasAttribute('open');
      });
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => {
        if (typeof searchModal.close === 'function') {
          searchModal.close(false);
        } else {
          searchModal.querySelector('details')?.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yotpo-reviews-lazy"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ALLOWED_REVIEW_SCRIPT = /^https:\/\/staticw2\.yotpo\.com\/.*\/widget\.js(?:[?#].*)?$/i;

  function normalizeScriptSrc(src){
    if (!src) return '';
    try {
      return new URL(src, window.location.href).href;
    } catch(_){
      return '';
    }
  }

  function hasScriptSrc(src){
    return Array.prototype.some.call(document.scripts, function(script){
      return script.src === src;
    });
  }

  function scriptType(old){
    return (old.getAttribute('type') || '').trim().toLowerCase();
  }

  function isInertConfigScript(old){
    var type = scriptType(old);
    return type && !/^(?:text|application)\/(?:javascript|ecmascript)$/i.test(type) && type !== 'module';
  }

  function requestYotpoLoad(attempt){
    if (window.__riseLoadYotpo) {
      window.__riseLoadYotpo({ force: true });
      return;
    }

    if (window.yotpo && window.yotpo.refreshWidgets) {
      try { window.yotpo.refreshWidgets(); } catch(_){}
      return;
    }

    if (attempt < 8) {
      setTimeout(function(){ requestYotpoLoad(attempt + 1); }, 250);
    }
  }

  function activate(wrap){
    if (!wrap) return;
    var mount = wrap.querySelector('.yotpo-lazy-mount');
    var tpl = wrap.querySelector('template.yotpo-lazy-template');
    if (!wrap || !mount || !tpl) return;
    if (mount.__activated) return;
    mount.__activated = true;

    // template の中身を挿入
    var frag = tpl.content ? tpl.content.cloneNode(true) : (function(){
      var d = document.createElement('div'); d.innerHTML = tpl.innerHTML;
      var f = document.createDocumentFragment();
      while (d.firstChild) f.appendChild(d.firstChild);
      return f;
    })();
    mount.appendChild(frag);

    // Only allow the expected external Yotpo loader. Inline scripts are discarded.
    mount.querySelectorAll('script').forEach(function(old){
      var src = normalizeScriptSrc(old.getAttribute('src') || '');
      if (!src && scriptType(old) === 'application/ld+json') {
        old.remove();
        return;
      }
      if (!src && isInertConfigScript(old)) {
        return;
      }
      if (!src) {
        old.remove();
        return;
      }
      if (!ALLOWED_REVIEW_SCRIPT.test(src)) {
        if (window.console && console.warn) console.warn('[yotpo-lazy] blocked unexpected script:', src);
        old.remove();
        return;
      }
      if (hasScriptSrc(src) || window.yotpo) {
        old.remove();
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      old.replaceWith(s);
    });

    requestYotpoLoad(0);
  }

  function setupWrap(wrap){
    if (!wrap || wrap.__yotpoLazyBound) return;
    wrap.__yotpoLazyBound = true;

    if (window.Shopify && Shopify.designMode) {
      activate(wrap);
      return;
    }

    // ① IO でレビュー欄の直前まで遅延
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        if (es.some(function(e){ return e.isIntersecting; })){
          io.disconnect();
          activate(wrap);
        }
      }, { rootMargin: '200px 0px' });
      io.observe(wrap);
    }

    // ② 未対応ブラウザや未スクロール時は、ユーザー操作後だけ保険で読み込む
    ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function(eventName){
      window.addEventListener(eventName, function(){
        setTimeout(function(){ activate(wrap); }, 8000);
      }, { once:true, passive:true });
    });
  }

  function setupRoot(root){
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-yotpo-lazy]').forEach(setupWrap);
  }

  setupRoot(document);

  // セクション再描画時も再バインド
  document.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) setupRoot(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
